module.exports = __webpack_public_path__ + "static/media/team5.7ca88e78.jpg";